// extracted by mini-css-extract-plugin
export var container = "_ga-0";
export var infoIcon = "_ga-2";
export var internalLabel = "_ga-3";
export var titleRowCol = "_ga-1";